import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './SalesOrders.frontend.types'

@Injectable({ providedIn: 'root' })
export class SalesOrders_process_shipments_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { shipments: { order_id: number, shipments: number[] }[], options: { processing_strategy_code: string, cartonization_strategy_code: string, break_child_serials?: boolean } }): Promise<{ shipment_results?: { shipment_id: number, is_succeeded: boolean, reason?: string }[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.shipments)) {
      $missingRequiredInParams.push('\'shipments\'');
    }
    if (isNil($inParams.options)) {
      $missingRequiredInParams.push('\'options\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

